<div class="cat-heading-section mb-16">
    <div>
        <h2 class="m-0 mb-8 font-size-22">Category Configuration</h2>
        <p class="m-0 sub-text-heading">Categories are equivalent to deliverable types and documents.</p>
    </div>
    <div>
        <app-button [type]="'primary'" [buttonType]="'button'" [buttonText]="'Add Category'" [iconSrc]="'/assets/icons/Plus_button.svg'" (click)="addCategory()"></app-button>
    </div>
</div>
<div class="cat-mgmt-card">
    <mat-card class="p-24">
        <div class="d-flex justify-content-between align-items-center mb-16">
            <h3 class="m-0">Added Categories ({{activeCategories.length}})</h3>
            <div class="position-relative search-input-box">
                <input type="text" placeholder="Search" [(ngModel)]="searchData" (ngModelChange)="onValueChange()" #searchInput class="p-8 search-input" style="width: 94%; font-size: 14px;">
                <div class="position-absolute search-icon cursor-pointer">
                    <div class="d-flex align-items-center" style="gap: 8px;">
                        <img src="/assets/admin-images/search_cancel_icon.png" style="height: 20px;" alt="search" (click)="clearSearch()" *ngIf="searchData?.length">
                        <span style="color: #E1E1EA;" *ngIf="searchData?.length">|</span>
                        <img src="/assets/icons/Group 57082.svg" alt="search" (click)="onSearch(searchInput.value)">
                    </div>
                </div>
            </div>
        </div>

        <mat-tab-group animationDuration="0ms">
            <mat-tab label="Active ({{activeCategories.length}})" class="mb-8 font-size-16 font-weight-700">

                <div class="mt-18 search-cat d-flex align-items-center cat-container" *ngIf="isAddCategoryVisible">
                    <input type="text" placeholder="Enter Category" [(ngModel)]="categoryName" class="w-100"/>
                    <div class="d-flex">
                        <img src="/assets/admin-images/cancel.png" alt="" class="p-8 cursor-pointer" (click)="closeNewCategorySubCategory(null, true)" style="height: 24px;">
                        <img src="/assets/admin-images/check_circle.png" alt="" class="p-8 cursor-pointer" style="height: 24px;" (click)="submitCategoryOrSubCategory(null, true)">
                    </div>
                </div>

                <div *ngIf="activeCategories.length">
                    <div class="mt-18 cat-container" *ngFor="let activeCat of activeCategories">
                        <div class="d-flex justify-content-between align-items-center">
                            <ng-container *ngIf="activeCat.isEditing; else showName">
                                <div class="search-cat d-flex align-items-center cat-container w-100">
                                    <input type="text" placeholder="Enter Category" [(ngModel)]="activeCat.name" class="w-100" #newCatName/>
                                    <div class="d-flex">
                                        <img src="/assets/admin-images/cancel.png" alt="" class="p-8 cursor-pointer" style="height: 24px;" (click)="closeNewCategoryInput(activeCat)">
                                        <img src="/assets/admin-images/check_circle.png" alt="" class="p-8 cursor-pointer" style="height: 24px;" (click)="submitExistingCategory(activeCat, newCatName)">
                                    </div>
                                </div>
                            </ng-container>
                        
                            <ng-template #showName>
                                <p class="m-0">{{ activeCat?.name }}</p>
                                <div class="d-flex align-items-center font-weight-700 add-sub-cat">
                                    <div class="d-flex align-items-center cursor-pointer" (click)="addSubCategory(activeCat)">
                                        <img src="/assets/admin-images/add_btn.png" style="color: #503291; height: 16px;" class="mr-6" alt=""/>
                                        <p style="color: #503291;" class="m-0 font-size-14 mr-8">Add Sub Category</p>
                                    </div>
                                    <div>
                                        <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Example icon-button with a menu">
                                            <img src="/assets/admin-images/see_more_img.png" alt="see more" style="height: 24px;"/>
                                        </button>
                                        <mat-menu #menu="matMenu">
                                            <button mat-menu-item>
                                                <div class="d-flex align-items-center" (click)="rename(activeCat)">
                                                    <img src="/assets/admin-images/pen_icon.png" alt="edit" style="height: 20px;" class="mr-6"/>
                                                    <span>Rename</span>
                                                </div>
                                            </button>
                                            <button mat-menu-item (click)="markActiveInactive(activeCat)">
                                                <div class="d-flex align-items-center">
                                                    <img src="/assets/admin-images/toggle_off.png" alt="toggle icon" style="height: 20px;" class="mr-6"/>
                                                    <span>Mark as Inactive</span>
                                                </div>
                                            </button>
                                            <button mat-menu-item (click)="deleteCategory(activeCat)">
                                                <div class="d-flex align-items-center">
                                                    <img src="/assets/admin-images/bin_icon.png" alt="delete" style="height: 20px;" class="mr-6"/>
                                                    <span>Delete</span>
                                                </div>
                                            </button>
                                        </mat-menu>
                                    </div>
                                    
                                    </div>
                                </ng-template>
                        </div>
                        <div>
                            <div class="mt-18 sub-cat-search d-flex align-items-center sub-cat-container" *ngIf="activeCat.isAddSubCategoryVisible">
                                <input type="text" placeholder="Enter Subcategory name" [(ngModel)]="subCategoryName" class="w-100"/>
                                <div class="d-flex">
                                    <img src="/assets/admin-images/cancel.png" alt="" class="p-8 cursor-pointer" style="height: 24px;" (click)="closeNewCategorySubCategory(activeCat, false)">
                                    <img src="/assets/admin-images/check_circle.png" alt="" class="p-8 cursor-pointer" style="height: 24px;" (click)="submitCategoryOrSubCategory(activeCat, false)">
                                </div>
                            </div>
                            <div *ngIf="activeCat?.sub_categories?.length">
                                <ng-container *ngFor="let subCat of activeCat.sub_categories">
                                    <div class="sub-cat-container showOnhover d-flex justify-content-between align-items-center p-8">
                                        <ng-container *ngIf="subCat.isEditing; else showSubCategoryName">
                                            <div class="sub-cat-search d-flex align-items-center sub-cat-container mt-0 w-100">
                                                <input type="text" placeholder="Enter Subcategory name" [(ngModel)]="subCat.name" #subCatName class="w-100"/>
                                                <div class="d-flex">
                                                    <img src="/assets/admin-images/cancel.png" alt="" class="p-8 cursor-pointer" style="height: 24px;" (click)="closeSubCatInput(activeCat,subCat)">
                                                    <img src="/assets/admin-images/check_circle.png" alt="" class="p-8 cursor-pointer" style="height: 24px;" (click)="submitExistingSubCategory(activeCat, subCat, subCatName)">
                                                </div>
                                            </div>
                                        </ng-container>
                        
                                        <ng-template #showSubCategoryName>
                                            <p class="m-0 sub-category">{{subCat?.name}}</p>
                                            <button mat-icon-button [matMenuTriggerFor]="submenu" aria-label="icon-button with a menu" class="sub-menu-see-more">
                                                <img src="/assets/admin-images/see_more_img.png" alt="see more" style="height: 24px;" class="mr-8"/>
                                            </button>
                                        </ng-template>
                                        
                                    </div>
                                    <mat-menu #submenu="matMenu">
                                        <button mat-menu-item (click)="editSubCategory(subCat)">
                                            <div class="d-flex align-items-center">
                                                <img src="/assets/admin-images/pen_icon.png" alt="edit" style="height: 20px;" class="mr-6"/>
                                                <span>Rename</span>
                                            </div>
                                        </button>
                                        <button mat-menu-item (click)="deleteSubCategory(subCat, activeCat)">
                                            <div class="d-flex align-items-center">
                                                <img src="/assets/admin-images/bin_icon.png" alt="delete" style="height: 20px;" class="mr-6"/>
                                                <span>Delete</span>
                                            </div>
                                        </button>
                                    </mat-menu>
                                </ng-container>
                            </div>
                        </div>
                    </div>
                </div>
                <div style="margin: 30px; font-size: 24px; font-weight: 700; text-align: center;" *ngIf="!activeCategories.length">No results found</div>

            </mat-tab>
            <mat-tab label="Inactive ({{inactiveCategories.length}})" class="mb-8 font-size-16 font-weight-700">
                <div class="mt-18 search-cat d-flex align-items-center cat-container" *ngIf="isAddCategoryVisible">
                    <input type="text" placeholder="Enter Category" [(ngModel)]="categoryName" class="w-100"/>
                    <div class="d-flex">
                        <img src="/assets/admin-images/cancel.png" alt="" class="p-8 cursor-pointer" (click)="closeNewCategorySubCategory(null, true)" style="height: 24px;">
                        <img src="/assets/admin-images/check_circle.png" alt="" class="p-8 cursor-pointer" style="height: 24px;" (click)="submitCategoryOrSubCategory(null, true)">
                    </div>
                </div>

                <div *ngIf="inactiveCategories.length">
                    <div class="mt-18 cat-container" *ngFor="let inActiveCat of inactiveCategories">
                        <div class="d-flex justify-content-between align-items-center">
                            <ng-container *ngIf="inActiveCat.isEditing; else showName">
                                <div class="search-cat d-flex align-items-center cat-container w-100">
                                    <input type="text" placeholder="Enter Category" [(ngModel)]="inActiveCat.name" class="w-100" #newCatName/>
                                    <div class="d-flex">
                                        <img src="/assets/admin-images/cancel.png" alt="" class="p-8 cursor-pointer" style="height: 24px;" (click)="closeNewCategoryInput(inActiveCat)">
                                        <img src="/assets/admin-images/check_circle.png" alt="" class="p-8 cursor-pointer" style="height: 24px;" (click)="submitExistingCategory(inActiveCat, newCatName)">
                                    </div>
                                </div>
                            </ng-container>
                        
                            <ng-template #showName>
                                <p class="m-0">{{ inActiveCat?.name }}</p>
                                <div class="d-flex align-items-center font-weight-700 add-sub-cat">
                                    <div class="d-flex align-items-center cursor-pointer" (click)="addSubCategory(inActiveCat)">
                                        <img src="/assets/admin-images/add_btn.png" style="color: #503291; height: 16px;" class="mr-6" alt=""/>
                                        <p style="color: #503291;" class="m-0 font-size-14 mr-8">Add Sub Category</p>
                                    </div>
                                    <div>
                                        <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Example icon-button with a menu">
                                            <img src="/assets/admin-images/see_more_img.png" alt="see more" style="height: 24px;"/>
                                        </button>
                                        <mat-menu #menu="matMenu">
                                            <button mat-menu-item>
                                                <div class="d-flex align-items-center" (click)="rename(inActiveCat)">
                                                    <img src="/assets/admin-images/pen_icon.png" alt="edit" style="height: 20px;" class="mr-6"/>
                                                    <span>Rename</span>
                                                </div>
                                            </button>
                                            <button mat-menu-item (click)="markActiveInactive(inActiveCat)">
                                                <div class="d-flex align-items-center">
                                                    <img src="/assets/admin-images/toggle_on.png" alt="toggle on icon" style="height: 20px;" class="mr-6"/>
                                                    <span>Mark as Active</span>
                                                </div>
                                            </button>
                                            <button mat-menu-item (click)="deleteCategory(inActiveCat)">
                                                <div class="d-flex align-items-center">
                                                    <img src="/assets/admin-images/bin_icon.png" alt="delete" style="height: 20px;" class="mr-6"/>
                                                    <span>Delete</span>
                                                </div>
                                            </button>
                                        </mat-menu>
                                    </div>
                                    
                                    </div>
                                </ng-template>
                        </div>
                        <div>
                            <div class="mt-18 sub-cat-search d-flex align-items-center sub-cat-container" *ngIf="inActiveCat.isAddSubCategoryVisible">
                                <input type="text" placeholder="Enter Subcategory name" [(ngModel)]="subCategoryName" class="w-100"/>
                                <div class="d-flex">
                                    <img src="/assets/admin-images/cancel.png" alt="" class="p-8 cursor-pointer" style="height: 24px;" (click)="closeNewCategorySubCategory(inActiveCat, false)">
                                    <img src="/assets/admin-images/check_circle.png" alt="" class="p-8 cursor-pointer" style="height: 24px;" (click)="submitCategoryOrSubCategory(inActiveCat, false)">
                                </div>
                            </div>
                            <div *ngIf="inActiveCat?.sub_categories?.length">
                                <ng-container *ngFor="let subCat of inActiveCat.sub_categories">
                                    <div class="sub-cat-container showOnhover d-flex justify-content-between align-items-center p-8">
                                        <ng-container *ngIf="subCat.isEditing; else showSubCategoryName">
                                            <div class="sub-cat-search d-flex align-items-center sub-cat-container mt-0 w-100">
                                                <input type="text" placeholder="Enter Subcategory name" [(ngModel)]="subCat.name" #subCatName class="w-100"/>
                                                <div class="d-flex">
                                                    <img src="/assets/admin-images/cancel.png" alt="" class="p-8 cursor-pointer" style="height: 24px;" (click)="closeSubCatInput(inActiveCat,subCat)">
                                                    <img src="/assets/admin-images/check_circle.png" alt="" class="p-8 cursor-pointer" style="height: 24px;" (click)="submitExistingSubCategory(inActiveCat, subCat, subCatName)">
                                                </div>
                                            </div>
                                        </ng-container>
                        
                                        <ng-template #showSubCategoryName>
                                            <p class="m-0 sub-category">{{subCat?.name}}</p>
                                            <button mat-icon-button [matMenuTriggerFor]="submenu" aria-label="icon-button with a menu" class="sub-menu-see-more">
                                                <img src="/assets/admin-images/see_more_img.png" alt="see more" style="height: 24px;" class="mr-8"/>
                                            </button>
                                        </ng-template>
                                        
                                    </div>
                                    <mat-menu #submenu="matMenu">
                                        <button mat-menu-item (click)="editSubCategory(subCat)">
                                            <div class="d-flex align-items-center">
                                                <img src="/assets/admin-images/pen_icon.png" alt="edit" style="height: 20px;" class="mr-6"/>
                                                <span>Rename</span>
                                            </div>
                                        </button>
                                        <button mat-menu-item (click)="deleteSubCategory(subCat, inActiveCat)">
                                            <div class="d-flex align-items-center">
                                                <img src="/assets/admin-images/bin_icon.png" alt="delete" style="height: 20px;" class="mr-6"/>
                                                <span>Delete</span>
                                            </div>
                                        </button>
                                    </mat-menu>
                                </ng-container>
                            </div>
                        </div>
                    </div>
                </div>
                <div style="margin: 30px; font-size: 24px; font-weight: 700; text-align: center;" *ngIf="!inactiveCategories.length">No results found</div>

            </mat-tab>
        </mat-tab-group>
    </mat-card>
</div>
@if(isLoading){
    <app-loader></app-loader>
}